import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

export type CustomNumberFormatProps = {
    showLessThan1Km?: boolean;
} & NumberFormatProps;

const DistanceFormat: React.FC<CustomNumberFormatProps> = ({ value, showLessThan1Km, ...props }: CustomNumberFormatProps) => {
    const data = Number(value);

    return (
        data >= 1 ?
            <NumberFormat
                value={data}
                displayType={props.displayType ?? 'text'}
                thousandSeparator={' '}
                decimalSeparator={','}
                decimalScale={3}
                fixedDecimalScale={false}
                suffix={' km'}
                {...props}
            />
            :
            showLessThan1Km ?
                <div>{'<1 km'}</div>
                :
                <NumberFormat
                    value={data * 1000}
                    displayType={props.displayType ?? 'text'}
                    thousandSeparator={' '}
                    decimalSeparator={','}
                    decimalScale={0}
                    fixedDecimalScale={false}
                    suffix={data == 0 ? ' km' : ' m'}
                    {...props}
                />

    );
};

export default DistanceFormat;
